import {CommonModule, HashLocationStrategy, LocationStrategy} from '@angular/common';
import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {HttpClientModule, HTTP_INTERCEPTORS} from '@angular/common/http';
import {NgxPaginationModule} from 'ngx-pagination';
import {appRoutingProviders, routing} from './app.routes';
import {AppComponent} from './app.component';
import {HeaderComponent} from './header/header.component';
import {LeftMenuComponent} from './left-menu/left-menu.component';
import {MenuListNetworkServersComponent} from './menu-list-network-servers/menu-list-network-servers.component';
import {GetAllNetworkServersComponent} from './get-all-network-servers/get-all-network-servers.component';
import {MenuListJoinServersComponent} from './menu-list-join-servers/menu-list-join-servers.component';
import {GetAllJoinServersComponent} from './get-all-join-servers/get-all-join-servers.component';
import {GetAllNetworkServersDetailComponent} from './get-all-network-servers-detail/get-all-network-servers-detail.component';
import {GetAllJoinServersDetailComponent} from './get-all-join-servers-detail/get-all-join-servers-detail.component';
import {PaginationCustomComponent} from './shared-components/pagination-custom/pagination-custom.component';
import {PaginationSimulateComponent} from './shared-components/pagination-simulate/pagination-simulate.component';
import {AdminUsersComponent} from './admin/admin-users/admin-users.component';
import {ModalComponent} from './modal/modal.component';
import {CreateJoinServersComponent} from './admin/create-join-servers/create-join-servers.component';
import {CreateNetworkServersComponent} from './admin/create-network-servers/create-network-servers.component';
import {CreateRoamingPartnersComponent} from './admin/create-roaming-partners/create-roaming-partners.component';
import {DeleteModalComponent} from './admin/delete-modal/delete-modal.component';
import {AddServingJoinServerComponent} from './admin/add-serving-join-server/add-serving-join-server.component';
import {AddServedNetworkServerComponent} from './admin/add-served-network-server/add-served-network-server.component';
import {InputEditComponent} from './admin/input-edit/input-edit.component';
import {SelectEditComponent} from './admin/select-edit/select-edit.component';
import {InputDynamicListComponent} from './admin/input-dynamic-list/input-dynamic-list.component';
import {EditPopoverButtonComponent} from './admin/edit-popover-button/edit-popover-button.component';
import {EditRoamingPartnersComponent} from './admin/edit-roaming-partners/edit-roaming-partners.component';
import {AuthtypeEditComponent} from './admin/authtype-edit/authtype-edit.component';
import {CidrPipe} from './pipes/cidr.pipe';
import {ProtocolEditComponent} from './admin/protocol-edit/protocol-edit.component';
import {SecurityEditComponent} from './admin/security-edit/security-edit.component';
import {ErrorModalComponent} from './shared-components/error-modal/error-modal.component';
import {AddRfparamSetComponent} from './admin/add-rfparam-set/add-rfparam-set.component';
import {HttpmodeEditComponent} from './admin/httpmode-edit/httpmode-edit.component';
import {EditActivationAgreementComponent} from './admin/edit-activation-agreement/edit-activation-agreement.component';
import {GetAllNetworkServerGroupsComponent} from './get-all-network-server-groups/get-all-network-server-groups.component';
import {MenuListNetworkServerGroupsComponent} from './menu-list-network-server-groups/menu-list-network-server-groups.component';
import {GetAllNetworkServerGroupsDetailComponent} from './get-all-network-server-groups-detail/get-all-network-server-groups-detail.component';
import {SelectNsGroupComponent} from './admin/select-ns-group/select-ns-group.component';
import {CreateNsGroupsComponent} from './admin/create-ns-groups/create-ns-groups.component';
import {MessageLogsComponent} from './message-logs/message-logs.component';
import {RoamingPartnersComponent} from './roaming-partners/roaming-partners.component';
import {ServedNetworkServersComponent} from './served-network-servers/served-network-servers.component';
import {ServingJoinServersComponent} from './serving-join-servers/serving-join-servers.component';
import {RfParamsetsComponent} from './rf-paramsets/rf-paramsets.component';
import {GroupNetworkServersComponent} from './group-network-servers/group-network-servers.component';
import {CreateRoamingCommunitiesComponent} from './admin/create-roaming-communities/create-roaming-communities.component';
import {RoamingCommunitiesComponent} from './roaming-communities/roaming-communities.component';
import {CreateRoamingCommunityMemberComponent} from './admin/create-roaming-community-member/create-roaming-community-member.component';
import {EditRoamingCommunityMemberComponent} from './admin/edit-roaming-community-member/edit-roaming-community-member.component';
import {EditRoamingCommunityComponent} from './admin/edit-roaming-community/edit-roaming-community.component';
import {RoamingCommunityMembersComponent} from './roaming-community-members/roaming-community-members.component';
import {RoamingAgreementPeeringsComponent} from './admin/roaming-agreement-peerings/roaming-agreement-peerings.component';
import {InputCheckboxComponent} from './admin/input-checkbox/input-checkbox.component';
import {NgxSelectModule} from 'ngx-select-ex';
import {PopoverModule} from 'ngx-bootstrap/popover';
import {UserVerificationService} from './services/user-verification.service';
import {HttpService} from './services/http.service';
import {DevAddrUtils} from './services/devAddr-utils.service';
import {KeycloakService} from './services/keycloak.service';
import {KeyCloakConfig} from './services/keycloak-config';
import {UiConfig} from './services/ui-config';
import {HttpInterceptorService} from './services/http-interceptor.service';
import {ErrorStreamService} from './shared-components/error-modal/error-stream.service';

export function loadHttpInterceptor(errorStreamService: ErrorStreamService) {
  return new HttpInterceptorService(errorStreamService);
}

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    LeftMenuComponent,
    MenuListNetworkServersComponent,
    GetAllNetworkServersComponent,
    MenuListJoinServersComponent,
    GetAllJoinServersComponent,
    GetAllNetworkServersDetailComponent,
    GetAllJoinServersDetailComponent,
    PaginationCustomComponent,
    PaginationSimulateComponent,
    AdminUsersComponent,
    ModalComponent,
    CreateJoinServersComponent,
    CreateNetworkServersComponent,
    CreateRoamingPartnersComponent,
    DeleteModalComponent,
    AddServingJoinServerComponent,
    AddServedNetworkServerComponent,
    InputEditComponent,
    SelectEditComponent,
    InputDynamicListComponent,
    EditPopoverButtonComponent,
    EditRoamingPartnersComponent,
    AuthtypeEditComponent,
    CidrPipe,
    ProtocolEditComponent,
    SecurityEditComponent,
    ErrorModalComponent,
    AddRfparamSetComponent,
    HttpmodeEditComponent,
    EditActivationAgreementComponent,
    GetAllNetworkServerGroupsComponent,
    MenuListNetworkServerGroupsComponent,
    GetAllNetworkServerGroupsDetailComponent,
    SelectNsGroupComponent,
    CreateNsGroupsComponent,
    MessageLogsComponent,
    RoamingPartnersComponent,
    ServedNetworkServersComponent,
    ServingJoinServersComponent,
    RfParamsetsComponent,
    GroupNetworkServersComponent,
    CreateRoamingCommunitiesComponent,
    RoamingCommunitiesComponent,
    CreateRoamingCommunityMemberComponent,
    EditRoamingCommunityMemberComponent,
    EditRoamingCommunityComponent,
    RoamingCommunityMembersComponent,
    RoamingAgreementPeeringsComponent,
    InputCheckboxComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    NgxPaginationModule,
    PopoverModule.forRoot(),
    routing,
    CommonModule,
    NgxSelectModule
  ],
  providers: [
    appRoutingProviders,
    KeyCloakConfig,
    UiConfig,
    {provide: LocationStrategy, useClass: HashLocationStrategy},
    UserVerificationService,
    HttpService,
    KeycloakService,
    ErrorStreamService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpInterceptorService,
      multi: true
    },
  ],
  bootstrap: [AppComponent]
})

export class AppModule {
}
